import axios from '../../axios';

export type ServiceResponse = {
  id: string;
  clientCode: string;
  clientName: string;
  taxId: string;
  balance: string;
  reconciliationStatus: string;
  documentCount: string;
  type: string;
  status: statusEnum;
};

type statusEnum = 'AGREED' | 'NOT_AGREED' | 'OTHER';

export type ServiceRequest = {
  month: string;
  year: string;
  type:string
};

export default async function getFinancialRepository(
  params: ServiceRequest
): Promise<ServiceResponse[]> {
  let res = await axios.get(`${process.env.REACT_APP_BASE_URL}/financial-operation`, {
    params: {
      month: params.month,
      year: params.year,
      type:params.type
    },
  });
  return res.data;
}
